"use client";
import React, { useState } from "react";
import { InputAdornment, TextField, Button, Typography, Link, Box, Grid, MenuItem } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faFacebook, faInstagram, faXing } from '@fortawesome/free-brands-svg-icons';
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import "react-phone-input-2/lib/style.css";
import countries from "world-countries";
import { useNavigate, useLocation } from 'react-router-dom';
// Format countries for react-select
const countryOptions = countries.map((country) => ({
  value: country.cca2,
  label: (
    <div style={{ display: "flex", alignItems: "center" }}>
      <img
        src={`https://flagcdn.com/w40/${country.cca2.toLowerCase()}.png`}
        alt={country.name.common}
        style={{ width: 20, height: 15, marginRight: 10 }}
      />
      {country.name.common}
    </div>
  ),
}));

const Contact = ({ scrollHome, scrollAbout, scrollServices, scrollContact }) => {
  
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState(null);
  const [teamSize, setTeamSize] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const iconMapping = {
    linkedin: faLinkedin,
    facebook: faFacebook,
    instagram: faInstagram,
    xing: faXing,
  };
  const teamSizeOptions = [
    { value: "1-5", label: "1-5" },
    { value: "6-10", label: "6-10" },
    { value: "11-20", label: "11-20" },
    { value: "21-50", label: "21-50" },
    { value: "50+", label: "50+" },
  ];

  const handleNavigation = (sectionId) => {
    if (location.pathname !== "/") {
      navigate(`/#${sectionId}`);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };
  return (
    <div className="bg-[#111D57] min-h-screen flex flex-col">
      {/* Contact Form Section */}
      <Grid container sx={{ flexGrow: 1 }}>
        <Grid container spacing={0} sx={{ flex: 1 }}>
          {/* Left Side: Contact Form */}
          <Grid item xs={12} md={6}>
            <Box sx={{ p: 6, color: "white" }}>
              <Typography variant="h4" gutterBottom>Get In Touch</Typography>
              <Typography variant="body1" paragraph>
                We’d love to hear from you! Whether you have questions, feedback, or are interested
                in learning more about our platform, our team is here to help.
              </Typography>

              {/* Name Field */}
              <TextField
                label="Name"
                variant="outlined"
                fullWidth
                sx={{
                  input: {
                    color: 'white',
                  },
                  '& .MuiInputLabel-root': {
                    color: 'white',
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'white',
                    },
                    '&:hover fieldset': {
                      borderColor: 'white',
                    },
                  },
                  marginBottom: 2,
                }}
              />

              {/* Email Field */}
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                sx={{
                  input: {
                    color: 'white',
                  },
                  '& .MuiInputLabel-root': {
                    color: 'white',
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'white',
                    },
                    '&:hover fieldset': {
                      borderColor: 'white',
                    },
                  },
                  marginBottom: 2,
                }}
              />

              {/* Country Selector */}
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Select Country</Typography>
              <Select
                options={countryOptions}
                value={country} // This will store the selected country
                onChange={(selectedOption) => setCountry(selectedOption)} // Update the selected country on change
                getOptionLabel={(e) => e.label} // To ensure the country name appears in the input field
                styles={{
                  control: (base) => ({
                    ...base,
                    height:"55px",
                    background: "#111D57", // Background color for the input control
                    borderRadius: 5,
                    color: "white", // Text color for the input field
                    '&:hover': {
                      borderColor: 'white',
                    },
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "white", // Sets the placeholder text to white
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: 'white', // Text color for the selected value
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: '#111D57', // Dropdown menu background color
                    color: 'white', // Text color for the dropdown items
                    borderRadius: 5,
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2)', // Optional: subtle shadow for the dropdown
                    zIndex: 9999, // Ensures the dropdown stays on top
                  }),
                  option: (base) => ({
                    ...base,
                    color: 'white', // Text color for each option
                    backgroundColor: '#111D57', // Background color for each option
                    '&:hover': {
                      backgroundColor: '#536DFE', // Hover background color for options
                    },
                    padding: '10px 12px', // Option padding for better spacing
                  }),
                }}
              />



              {/* Phone Number Field */}
              <Typography 
              variant="subtitle1" 
              sx={{ mt: 2 }}>Phone Number</Typography>
              <PhoneInput
                country="us"
                value={phone}
                onChange={setPhone}
                inputStyle={{
                  width: "100%",
                  height:"55px",
                  color: 'white',
                  backgroundColor: '#111D57',
                  borderColor: 'white',
                  borderRadius: 5,
                }}
                containerStyle={{
                  borderRadius: 5,
                  marginBottom: 20,
                }}
                dropdownStyle={{
                  backgroundColor: '#111D57', // Dropdown background color
                  color: 'white', // Dropdown text color
                  borderRadius: 5, // Dropdown border radius
                }}
                 dropdownClass="custom-phone-input"
        buttonClass="custom-phone-input"
              />

              {/* Hospital Name */}
              <TextField
                label="Hospital Name"
                variant="outlined"
                fullWidth
                sx={{
                  input: {
                    color: 'white',
                  },
                  '& .MuiInputLabel-root': {
                    color: 'white',
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'white',
                    },
                    '&:hover fieldset': {
                      borderColor: 'white',
                    },
                  },
                  marginBottom: 2,
                }}
              />
              {/* Dropdown for number of team members */}
              <Typography variant="subtitle1" sx={{ mb: 1 }}>Team Members</Typography>
              <Select
                options={teamSizeOptions}
                value={teamSize}
                onChange={setTeamSize}
                placeholder="Select number of team members"
                getOptionLabel={(e) => e.label} // Ensures the selected value appears properly in the input field
                styles={{
                  control: (base) => ({
                    ...base,
                    background: "#111D57", // Slightly darkened background for a more sophisticated look
                    color:"white",
                   
                    fontSize: "16px", // Improved font size for readability

                    borderColor: 'white', // Border changes to lighter blue on hover for visual feedback
                    marginBottom: "17px",
                    padding: "8px 6px", // Padding for better spacing
                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.15)", // Subtle shadow for depth
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "white", // Sets the placeholder text to white
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: "white", // Makes the selected input text white
                  }),
              
                  input: (base) => ({
                    ...base,
                    color: "white", // Ensures user-typed text is white
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: '#111D57', // Dark background for the dropdown menu
                    color: 'red', // White text for the dropdown items
                    borderRadius: 8, // Matching rounded corners for the menu
                    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)', // Stronger shadow for better contrast
                    zIndex: 9999, // Ensures the dropdown stays on top
                  }),
                  option: (base) => ({
                    ...base,
                    color: 'white', // White text for options
                    backgroundColor: '#111D57', // Same background as the menu
                    cursor: 'pointer', // Pointer cursor for clickable options
                    '&:hover': {
                      backgroundColor: '#2C3E8F', // Darker blue on hover for better interaction feedback
                    },
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    color: '#fff', // Make the dropdown indicator white to match the design
                    '&:hover': {
                      color: '#536DFE', // Lighter blue on hover for better visibility
                    },
                  }),

                }}
              />

              {/* Subject */}
              <TextField
                label="Subject"
                variant="outlined"
                fullWidth
                sx={{
                  input: {
                    color: 'white',
                  },
                  '& .MuiInputLabel-root': {
                    color: 'white',
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'white',
                    },
                    '&:hover fieldset': {
                      borderColor: 'white',
                    },
                  },
                  marginBottom: 2,
                }}
              />

              {/* Message Field */}
              <TextField
                label="Message"
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                sx={{
                  input: {
                    color: 'white',
                  },
                  '& .MuiInputLabel-root': {
                    color: 'white',
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: 'white',
                    },
                    '&:hover fieldset': {
                      borderColor: 'white',
                    },
                  },
                  marginBottom: 2,
                }}
              />

              {/* Submit Button */}
              <Button variant="contained" color="primary" sx={{ mt: 2 }}>Submit</Button>
            </Box>
          </Grid>

          {/* Right Side: Image */}
          <Grid item xs={12} md={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Box sx={{ width: '100%', height: '100%' }}>
              <img
                src="/contactimage.svg"
                alt="Contact Us"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </Box>
          </Grid>
        </Grid>

        {/* Footer Section */}
        <Grid container sx={{ backgroundColor: '#16215A', padding: 4, width: '100%' }}>
          <Grid item xs={12} md={6}>
            <Box sx={{ mb: 4 }}>
              <img
                src="/logo.svg"
                alt="logo"
                style={{ width: 120, marginBottom: 16 }}
              />
              <Typography variant="body1" color="common.white" sx={{ maxWidth: 300 }}>
                A smarter way for healthcare workers to manage shifts, communicate effortlessly,
                and share knowledge—designed to support your every need.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 4 }}>
              {/* Quick Links */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
    <Typography
      onClick={() => handleNavigation("home")}
      sx={{ cursor: 'pointer', color: 'common.white' }}
    >
      Home
    </Typography>
    <Typography
      onClick={() => handleNavigation("about")}
      sx={{ cursor: 'pointer', color: 'common.white' }}
    >
      About Us
    </Typography>
    <Typography
      onClick={() => handleNavigation("services")}
      sx={{ cursor: 'pointer', color: 'common.white' }}
    >
      Services
    </Typography>
    <Typography
      onClick={() => handleNavigation("contact")}
      sx={{ cursor: 'pointer', color: 'common.white' }}
    >
      Contact
    </Typography>
  </Box>


              {/* Legal Links */}
              <Box>
                <Typography variant="subtitle1" color="common.white" fontWeight="bold" gutterBottom>
                  Legal
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Link href="#" color="common.white" sx={{ textDecoration: 'none' }}>
                    Terms of Services
                  </Link>
                  <Link href="#" color="common.white" sx={{ textDecoration: 'none' }}>
                    Privacy
                  </Link>
                </Box>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ borderBottom: '1px solid #2F396C', width: '100%', my: 4 }} />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="body2" color="common.white">
                © 2025 Qyser. All rights reserved.
              </Typography>

              <Box sx={{ display: 'flex', gap: 2 }}>
                {['linkedin', 'facebook', 'instagram', 'xing'].map((icon) => (
                  <Button
                    key={icon}
                    variant="contained"
                    sx={{
                      minWidth: 35,
                      height: 35,
                      borderRadius: 5,
                      backgroundColor: '#16215A',
                      '&:hover': {
                        background: 'linear-gradient(44.99deg, #534DF4 20.69%, #AA58F2 79.31%)',
                      },
                    }}
                  >
                    <FontAwesomeIcon icon={iconMapping[icon]} />
                  </Button>
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Contact;
